import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';
import BotonDescargarExel from '../../../../components/atoms/BotonDescargarExel/BotonDescargarExel';
import ButtonGris from '../../../../components/atoms/ButtonGris/ButtonGris';
import EditarIncidenciaGeneral from './EditarIncidenciaGeneral';
import DetalleServicioModal from './DetalleServicioModal';
import '../CierreDeTurno.scss';

const ModalIncidencias = ({
    visible,
    onHide,
    cardActiva,
    dtRef,
    datosModalFiltrados,
    userData,
    globalFilter,
    setGlobalFilter,
    proveedorFilter,
    setProveedorFilter,
    opcionesProveedor,
    modoDetalle,
    causas = [],
    efectos = [],
    onEditarGuardado,
}) => {
    const [editVisible, setEditVisible] = useState(false);
    const [rowEditar,   setRowEditar]   = useState(null);
    const [mapaVisible, setMapaVisible] = useState(false);
    const [rowMapa,     setRowMapa]     = useState(null);

    const mostrarEditar = cardActiva?.key === 'generales' && modoDetalle === 'nuevo';
    const mostrarMapa   = cardActiva?.key === 'todos_los_servicios';

    const editarTpl = (row) => (
        <ButtonGris onClick={() => { setRowEditar(row); setEditVisible(true); }} width="80px">
            Editar
        </ButtonGris>
    );

    const verMapaTpl = (row) => (
        <ButtonGris onClick={() => { setRowMapa(row); setMapaVisible(true); }} width="60px">
            Ver
        </ButtonGris>
    );

    const encabezado = () => (
        <div className="modalEncabezado">
            <span>{cardActiva?.titulo}</span>
            <div className="modalAcciones">
                {cardActiva?.key === 'servicios_por_proveedor' && (
                    <MultiSelect
                        value={proveedorFilter}
                        options={opcionesProveedor}
                        onChange={(e) => setProveedorFilter(e.value ?? [])}
                        placeholder="Filtrar proveedor..."
                        display="chip"
                        showClear
                        className="multiSelectProveedor"
                    />
                )}
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText
                        value={globalFilter}
                        onChange={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Buscar..."
                        className="buscadorModal"
                    />
                </IconField>
                <BotonDescargarExel
                    nombreArchivo={cardActiva?.titulo ?? 'datos'}
                    datos={{ data: datosModalFiltrados }}
                />
            </div>
        </div>
    );

    return (
        <>
            <Dialog
                visible={visible}
                onHide={onHide}
                header={encabezado}
                maximizable
                className="modalDashboard"
                style={{ width: '90vw', height: '85vh' }}
                contentStyle={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: '0' }}
            >
                <DataTable
                    ref={dtRef}
                    value={datosModalFiltrados}
                    globalFilter={globalFilter}
                    emptyMessage="Sin registros"
                    size="small"
                    stripedRows
                    scrollable
                    scrollHeight="flex"
                    exportFilename={cardActiva?.titulo ?? 'datos'}
                    className="dashDataTable"
                >
                    {cardActiva?.columnas.map((col) => (
                        <Column
                            key={col.field}
                            field={col.field}
                            header={col.header}
                            sortable
                            body={col.body ?? undefined}
                            style={col.style ?? undefined}
                        />
                    ))}
                    {mostrarEditar && (
                        <Column
                            header=""
                            body={editarTpl}
                            style={{ width: '90px', textAlign: 'center' }}
                            frozen
                            alignFrozen="right"
                        />
                    )}
                    {mostrarMapa && (
                        <Column
                            header=""
                            body={verMapaTpl}
                            style={{ width: '70px', textAlign: 'center' }}
                            frozen
                            alignFrozen="right"
                        />
                    )}
                </DataTable>
            </Dialog>

            <EditarIncidenciaGeneral
                visible={editVisible}
                onHide={() => setEditVisible(false)}
                row={rowEditar}
                causas={causas}
                onGuardado={onEditarGuardado}
                userData={userData}
            />

            {mapaVisible && rowMapa && (
                <DetalleServicioModal
                    bitacora={rowMapa.ID_BITACORA}
                    servicio={rowMapa.NOMBRE_RUTA}
                    estatus={rowMapa.ID_ESTATUS}
                    incidencias_viaje={
                        Array.isArray(rowMapa.INCIDENCIAS_VIAJE_JSON)
                            ? rowMapa.INCIDENCIAS_VIAJE_JSON
                            : (rowMapa.INCIDENCIAS_VIAJE_JSON
                                ? JSON.parse(rowMapa.INCIDENCIAS_VIAJE_JSON)
                                : [])
                    }
                    userData={userData}
                    onClose={() => { setMapaVisible(false); setRowMapa(null); }}
                />
            )}
        </>
    );
};

export default ModalIncidencias;
